import React from "react";
import * as styles from "./CustomPromoErrorModal.module.scss";
import Modal from "../../Modal/Modal";
import {
  Button,
  ButtonsContainer,
  Icon,
  ModalBody
} from "@silversea-ssc/ui-components-react";
import { Trans } from "@lingui/react/macro";

type Props = {
  isOpen: boolean;
  onRequestClose?: () => void;
  title?: string;
};

const CustomPromoErrorModal: React.FC<Props> = ({
  isOpen,
  onRequestClose,
  title
}) => {
  return (
    <Modal
      modal={{ isOpen: true, onRequestClose: undefined }}
      size="small"
      dataContentName="error_modal"
    >
      <ModalBody variant="full" className={styles.modalBodyWrapper}>
        <div className={styles.errorIconContainer}>
          <React.Fragment>
            <Icon name="alert" size="2x" padding="inline" />{" "}
            <Trans>Offer not available</Trans>
          </React.Fragment>
        </div>
        <div className={styles.modalContent}>
          <div className={styles.title}>
            <Trans>We couldn't apply your promotion</Trans>
          </div>
          <div className={styles.body}>
            <Trans>
              We’re sorry - there was a problem retrieving your offer. The
              promotion may have expired, or there might be a technical issue
              with the link you used. Please double-check the expiration date in
              your email. If everything looks correct, our team will be happy to
              assist you further. You’ll find our contact details and
              availability just below.
            </Trans>
          </div>
          <div className={styles.contacts}>
            <span className={styles.phoneNumber}>
              <Trans>+1-888-978-4070</Trans>
            </span>
            <span className={styles.openings}>
              <Trans>
                Mon – Fri: 09:00 – 20:00 EST; Sat: 09:00 – 17:00 EST; Sun:
                Closed
              </Trans>
            </span>
          </div>
          <div className={styles.buttonsContainer}>
            <ButtonsContainer mobileFullSize>
              <Button
                renderAs="button"
                dataContentPiece="customPromoErrorModal"
                variant="primary"
              >
                <Trans>Explore other offers</Trans>
              </Button>
              <Button
                renderAs="button"
                dataContentPiece="customPromoErrorModal"
                variant="secondary"
              >
                <Trans>Find your cruise</Trans>
              </Button>
            </ButtonsContainer>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default CustomPromoErrorModal;
